import { createI18n } from 'vue-i18n';
import { getNumberFormats } from '@/i18n/numberFormats';
import { getDateFormats } from '@/i18n/dateFormats';
import { availableLanguages, defaultLanguage } from '@sysarb/sysarb-types/general/locales';
import defaultTranslations from '@/lang/cu.json';

type TranslationObject = { [key: string]: TranslationObject | string };

function getValueAtPath(translationObject: unknown, path: string): string | undefined {
    if (typeof translationObject !== 'object') return undefined;
    const parts = path.split('.');
    let current: TranslationObject = translationObject as TranslationObject;

    for (const part of parts) {
        const value = current[part];
        if (value === undefined || typeof value === 'string') {
            return value;
        }
        current = value;
    }

    return undefined;
}

export const i18n = createI18n({
    legacy: false,
    locale: defaultLanguage,
    fallbackLocale: 'cu',
    messages: { cu: defaultTranslations },
    availableLocales: availableLanguages,
    numberFormats: getNumberFormats(),
    datetimeFormats: getDateFormats(),
    messageResolver: (translationObject, translationKeyPath) => {
        const value = getValueAtPath(translationObject, translationKeyPath);
        return value === '' || value === undefined ? null : value;
    },
    fallbackWarn: false,
    missingWarn: false
});
